const globalConfig = require('./global'); // 读取 global.js   
// 读取特定配置文件    
let Config = require(`./global/${globalConfig}`);

// 初始导出  
module.exports = {
    Config,
};